import React, { createContext, useContext } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var RadioContext = /*#__PURE__*/createContext(undefined);
export var RadioContextProvider = function RadioContextProvider(_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? {
      visualSize: 'medium',
      error: false
    } : _ref$value;
  return ___EmotionJSX(RadioContext.Provider, {
    value: value
  }, children);
};
var useRadioContext = function useRadioContext() {
  var context = useContext(RadioContext);
  return context;
};
export default useRadioContext;